const zIndexes = {
  bottom: 0,
  middle: 500,
  top: 900,
  modals: 2000
}

export default zIndexes
